<template>
  <BriefStep :title="title" :tooltip="tooltip">
    <template v-slot:content>
      <div class="brief-form">
        <div
          class="form__input-wrapper"
          :class="{ error: $v.form.domainInfo.$anyError, disabled: form.domainInfoSkip }"
        >
          <label for="domain-info" class="form__label uk-hidden">Domena</label>
          <input
            class="form-input"
            id="domain-info"
            type="text"
            name="domain-info"
            @input="event => delayTouchCounterComposition($v.form, 'domainInfo', event.target.value)"
          />
          <span class="form__error-message form__error-message--no-label">
            <template v-if="!$v.form.domainInfo.minLength">
              {{ validationMessage.minLength }}</template
            >
            <template v-if="!$v.form.domainInfo.required">
              {{ validationMessage.required }}</template
            >
          </span>
        </div>
        <div
          class="
            brief-step__skip-step
            form__input-wrapper
            form__input-wrapper--check
            form__input-wrapper--check-squer
          "
        >
          <input
            class=""
            id="domainInfoSkip"
            type="checkbox"
            name="domainInfoSkip"
            :value="form.domainInfoSkip"
            v-model.trim="form.domainInfoSkip"
            @change="delayTouch($v.form)"
          />
          <label for="domainInfoSkip" class="form__label">
            Pominąć ten krok?
          </label>
        </div>
      </div>
    </template>
  </BriefStep>
</template>
<script>
import { minLength, required } from 'vuelidate/lib/validators';

import stepValidation from '../../mixins/stepValidation';
import BriefStep from '../global/BriefStep.vue';

export default {
  name: 'DomainInfo',
  components: { BriefStep },
  mixins: [stepValidation],
  data: () => ({
    title:
      'Podaj nam swój adres. Spokojnie, nie potrzebujemy informacji o Twoim miejscu '
      + 'zamieszkania, a  o domenie (oczywiście, jeśli ją masz).',
    tooltip: 'Domena to, najprościej rzecz ujmując, adres strony internetowej.',
    form: {
      domainInfo: '',
      domainInfoSkip: false,
    },
  }),
  validations() {
    if (this.form.domainInfoSkip) {
      return {
        form: {
          domainInfo: {},
        },
      };
    }
    return {
      form: {
        domainInfo: {
          required,
          minLength: minLength(3),
        },
      },
    };
  },
};
</script>
<style scoped lang="scss">
.disabled {
  input {
    pointer-events: none;
    background-color: rgb(235, 235, 235);
    border-color: transparent;
  }
}
</style>
